export default "__VITE_ASSET__CeRZE$wp__"